<template>
  <print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :field-name="$t('회사명(필수)')" :board="this.board" :is-print="isPrint" />

    <!--    위험성평가 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>{{ $t("위험성평가 정보") }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t("평가대상") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.평가대상 }}</p>
          <ml-input v-else v-model="form.평가대상" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("평가자(대표)") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.평가자_대표 }}</p>
          <ml-input v-else v-model="form.평가자_대표" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("평가자(근로자)") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.평가자_근로자 }}</p>
          <ml-input v-else v-model="form.평가자_근로자" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("평가일") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.평가일 }}</p>
          <date-selector v-else v-model="form.평가일" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("실시기간") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.실시기간 }}</p>
          <DateSelectorRang v-else v-model="form.실시기간" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 위험성평가 -->
    <RiskTable v-model="form.riskList" class="mb-6" :is-print="isPrint" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableRiskAppraisalEp from "@/components/TableRiskAppraisalEp.vue";
import TableRiskAppraisalEp2 from "@/components/TableRiskAppraisalEp2.vue";
import PhotoUploadBeforeAfterTable from "@/views/modules/PhotoUploadBeforeAfterTable.vue";
import { required } from "vuelidate/lib/validators";
import Print from "./Print.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import RiskTable from "@/views/boards/single-page/1128/RiskTable.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";

export default {
  components: {
    RiskTable,
    NameWithSignatureRow,
    Print,
    TableRiskAppraisalEp,
    TableRiskAppraisalEp2,
    FileUploadModule,
    FileUploader,
    DateSelector,
    FieldSelectModule,
    PhotoUploadBeforeAfterTable,
    DateSelectorRang,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
      inputB_2: { required },
      inputB_4: { required },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      important: false,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }

        this.$emit("input", this.form);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        평가대상: "",
        평가자_대표: "",
        평가자_근로자: "",
        평가일: "",
        실시기간: "",

        fileList: [],
        riskList: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
